import Header from "../components/Header";
import ArticleList from "../components/ArticleList";
import Footer from "../components/Footer";

export default function Blog() {
  return (
    <>
      <Header />
      <ArticleList />
      <Footer />
    </>
  );
}
